/**
 * Bumzee Dual Range Price Slider
 * File: assets/bumzee-price-slider.js
 *
 * How it works:
 * - Two transparent <input type="range"> sit on top of each other
 * - JS reads both values, fills the orange track between them
 * - Hidden inputs carry the actual filter values to Shopify
 * - On mouseup/touchend it triggers the facets form submit
 */

(function () {
  'use strict';

  function initPriceSlider(wrapper) {
    const rangeMin   = parseFloat(wrapper.dataset.rangeMin)  || 0;
    const rangeMax   = parseFloat(wrapper.dataset.rangeMax)  || 10000;
    const currency   = wrapper.dataset.currency              || '₹';

    const thumbMin   = wrapper.querySelector('.bumzee-range--min');
    const thumbMax   = wrapper.querySelector('.bumzee-range--max');
    const rangeFill  = wrapper.querySelector('.bumzee-slider-range');
    const track      = wrapper.querySelector('.bumzee-slider-track');
    const labelMin   = wrapper.querySelector('.bumzee-price-display__min');
    const labelMax   = wrapper.querySelector('.bumzee-price-display__max');
    const hiddenMin  = wrapper.querySelector('.bumzee-price-min-hidden');
    const hiddenMax  = wrapper.querySelector('.bumzee-price-max-hidden');

    if (!thumbMin || !thumbMax) return;

    // Set initial thumb values from Liquid-rendered data
    let currentMin = parseFloat(wrapper.dataset.currentMin) || rangeMin;
    let currentMax = parseFloat(wrapper.dataset.currentMax) || rangeMax;

    thumbMin.min = rangeMin;
    thumbMin.max = rangeMax;
    thumbMin.value = currentMin;

    thumbMax.min = rangeMin;
    thumbMax.max = rangeMax;
    thumbMax.value = currentMax;

    // ── Format number as price label ──────────────────────────
    function formatPrice(val) {
      return currency + Math.round(val).toLocaleString('en-IN');
    }

    // ── Update the orange fill between thumbs ─────────────────
    function updateFill() {
      const minVal = parseFloat(thumbMin.value);
      const maxVal = parseFloat(thumbMax.value);
      const total  = rangeMax - rangeMin;

      const leftPct  = ((minVal - rangeMin) / total) * 100;
      const rightPct = ((rangeMax - maxVal) / total) * 100;

      rangeFill.style.left  = leftPct  + '%';
      rangeFill.style.right = rightPct + '%';

      // Update display labels
      if (labelMin) labelMin.textContent = formatPrice(minVal);
      if (labelMax) labelMax.textContent = formatPrice(maxVal);
    }

    // ── Update hidden inputs (for Shopify filter form submit) ─
    function updateHiddenInputs() {
      const minVal = parseFloat(thumbMin.value);
      const maxVal = parseFloat(thumbMax.value);

      if (hiddenMin) hiddenMin.value = minVal > rangeMin ? minVal : '';
      if (hiddenMax) hiddenMax.value = maxVal < rangeMax ? maxVal : '';
    }

    // ── Prevent min thumb from crossing max thumb ─────────────
    thumbMin.addEventListener('input', function () {
      const minVal = parseFloat(thumbMin.value);
      const maxVal = parseFloat(thumbMax.value);

      if (minVal >= maxVal) {
        thumbMin.value = maxVal - 1;
      }

      updateFill();
    });

    // ── Prevent max thumb from crossing min thumb ─────────────
    thumbMax.addEventListener('input', function () {
      const minVal = parseFloat(thumbMin.value);
      const maxVal = parseFloat(thumbMax.value);

      if (maxVal <= minVal) {
        thumbMax.value = minVal + 1;
      }

      updateFill();
    });

    // ── On release: update hidden inputs + trigger form submit ─
    function onDragEnd() {
      updateHiddenInputs();
      triggerFormSubmit(wrapper);
    }

    thumbMin.addEventListener('mouseup',   onDragEnd);
    thumbMin.addEventListener('touchend',  onDragEnd);
    thumbMax.addEventListener('mouseup',   onDragEnd);
    thumbMax.addEventListener('touchend',  onDragEnd);

    // ── Keyboard support (arrow keys update on keyup) ─────────
    thumbMin.addEventListener('keyup', function () {
      updateFill();
      updateHiddenInputs();
      triggerFormSubmit(wrapper);
    });

    thumbMax.addEventListener('keyup', function () {
      updateFill();
      updateHiddenInputs();
      triggerFormSubmit(wrapper);
    });

    // ── Initial render ────────────────────────────────────────
    updateFill();
    updateHiddenInputs();
  }

  // ── Find and submit the parent facets form ──────────────────
  function triggerFormSubmit(wrapper) {
    // Walk up the DOM to find the facets form
    const form = wrapper.closest('form');
    if (!form) return;

    // Dispatch a native change event so Horizon's facets.js picks it up
    const event = new Event('change', { bubbles: true });
    wrapper.querySelector('.bumzee-price-min-hidden').dispatchEvent(event);
  }

  // ── Init all sliders on page ────────────────────────────────
  function initAll() {
    const sliders = document.querySelectorAll('.bumzee-price-slider');
    sliders.forEach(initPriceSlider);
  }

  // ── Run on DOM ready ────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // ── Re-init after Shopify filter AJAX updates ───────────────
  // Horizon uses custom elements — observe DOM for re-renders
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          const newSliders = node.querySelectorAll
            ? node.querySelectorAll('.bumzee-price-slider')
            : [];
          newSliders.forEach(initPriceSlider);

          if (node.classList && node.classList.contains('bumzee-price-slider')) {
            initPriceSlider(node);
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
